import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import GettingStarted from '../candidate/Forms/ClientOnboarding/GettingStartedMui';

function ModalExampleBasic({ onClose}) {
  const [open, setOpen] = useState(true);
  const queryParams = new URLSearchParams(window.location.search);
  const candidateId = queryParams.get("candidateId");
  const { auth } = useSelector((state) => state.user.user);

  // Close modal when authenticated
  useEffect(() => {
    if (auth) {
      setOpen(false);
    }
  }, [auth]);

  const storedData = localStorage.getItem('currentUrlfromMap');

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
  setOpen(false);
  onClose(false)
}}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0,0,0,0.4)',
            backdropFilter: 'blur(4px)',
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: '20px',
            overflow: 'hidden',
            width: 500,
            position: 'relative',
          },
        }}
      >
        <IconButton
          onClick={() => {
    setOpen(false);
    onClose(false);
  }}
          sx={{
            position: 'absolute',
            top: 5,
            right: 5,
            zIndex: 10,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: 0, textAlign: 'center' }}>
          <GettingStarted
            title={candidateId ? 'Continue to Reveal Talent Details' : null}
            description={candidateId ? 'Get full access to 5 curated talent — completely free.' : null}
          />
        </DialogContent>
      </Dialog>

    </>
  );
}

export default ModalExampleBasic;
